export default __webpack_public_path__ + "static/media/publish_invite.dd200b66.svg";